import React, { useEffect, useState } from "react";
import "./report.css";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import {
    viewcashbook,
    viewfolioledgerreport,
    viewfoliotrialreport,
} from "../../../components/CommonSection/apiresources";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import { useLocation } from "react-router-dom";

const ViewReport = () => {
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [listViewDetails, setListViewDetails] = useState([]);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const reportName = queryParams.get("report") || "Report";

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    getViewReportList(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, []);
    console.log(reportName, 'reportName')
    const getViewReportList = (agencyID) => {
        const baseUrl =
            reportName === "Folio Ledger" ? viewfolioledgerreport : reportName === "Trial Report" ? viewfoliotrialreport : viewcashbook;
        let data = {
            AgencyId: agencyID,
        };
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setListViewDetails(reportName === "Trial Report" ? response.object : response.list);
                } else {
                    alert(`Message: ${response.message}`);
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                <div className="material-work-desk-new bg-white m-3" style={{ maxHeight: "95vh" }}>
                    <div className="report-container">
                        <div className="report-toolbar">
                            <div className="left-tools">
                                <button className="btn"><i className="fa fa-print" /> Print</button>
                                <button className="btn"><i className="fa fa-file-pdf-o" /> PDF</button>
                                <button className="btn"><i className="fa fa-envelope" /> Send in Email</button>
                            </div>
                            <div className="filter-section-report">
                                <label>By</label>
                                <select>
                                    <option>Transaction Date</option>
                                </select>
                                <label>On</label>
                                <select>
                                    <option>This Month</option>
                                </select>
                                <input type="date" defaultValue="2025-03-01" />
                                <input type="date" defaultValue="2025-03-25" />
                                <button className="btn filter-btn-report">Filter</button>
                            </div>
                        </div>

                        <div className="report-header">
                            <h2>{reportName}</h2>
                            <p>From 1/03/2025 to 26/03/2025 by Transaction Date</p>
                        </div>

                        <div className="report-table-wrapper">
                            {reportName === "Folio Ledger" ? (
                                <div className="folio-ledger-wrapper">
                                    {["Owner folios", "Tenant folios"].map((section, i) => {
                                        const isOwner = section === "Owner folios";
                                        const filteredFolios = listViewDetails.filter(f =>
                                            isOwner ? f.folioType === 5 : f.folioType === 4
                                        );

                                        return (
                                            <div key={i} className="folio-group">
                                                <h5 style={{ marginBottom: "1rem" }}>{section}</h5>

                                                {filteredFolios.map((folio, index) => (
                                                    <div key={index} className="folio-section">
                                                        <h4>
                                                            {folio.folioReference} - ({folio.folioCode}) {folio.propertyAddress}
                                                        </h4>
                                                        <table className="report-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Audit</th>
                                                                    <th>Date</th>
                                                                    <th>Type</th>
                                                                    <th>Details</th>
                                                                    <th>Debit</th>
                                                                    <th>Credit</th>
                                                                    <th>Balance</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="opening-row">
                                                                    <td colSpan="6"><span>Opening balance</span></td>
                                                                    <td>${folio.openBal.toFixed(2)}</td>
                                                                </tr>
                                                                {folio.folioLedgerTransactionDetails.map((txn, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{txn.auditno}</td>
                                                                        <td>
                                                                            {txn.createdAt === "0001-01-01T00:00:00"
                                                                                ? ""
                                                                                : new Date(txn.createdAt).toLocaleDateString()}
                                                                        </td>
                                                                        <td>{txn.sTransactionType}</td>
                                                                        <td>{txn.details}</td>
                                                                        <td>{txn.debit > 0 ? `$${txn.debit.toFixed(2)}` : ""}</td>
                                                                        <td>{txn.credit > 0 ? `$${txn.credit.toFixed(2)}` : ""}</td>
                                                                        <td>${txn.balance.toFixed(2)}</td>
                                                                    </tr>
                                                                ))}
                                                                <tr className="closing-row">
                                                                    <td colSpan="6"><span>Closing balance</span></td>
                                                                    <td>${folio.balance.toFixed(2)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <div className="subtotal-row">
                                                            <span className="debit-bal">
                                                                Debit: ${folio.debit.toFixed(2)} | Credit: ${folio.credit.toFixed(2)} | Balance: ${folio.balance.toFixed(2)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>

                            ) : reportName === "Trial Report" ? (
                                <div className="folio-trial-wrapper">
                                    {[
                                        { key: "ownerFolioList", label: "Owner folios" },
                                        { key: "tenantFolioList", label: "Tenant folios" },
                                        { key: "supplierFolioList", label: "Supplier folios" },
                                    ].map((section, i) => {
                                        const folios = listViewDetails[section.key] || [];

                                        const total = folios.reduce(
                                            (acc, f) => {
                                                acc.opening += f.openingBalance || 0;
                                                acc.debit += f.debit || 0;
                                                acc.credit += f.credit || 0;
                                                acc.closing += f.closing || 0;
                                                return acc;
                                            },
                                            { opening: 0, debit: 0, credit: 0, closing: 0 }
                                        );

                                        return (
                                            <div key={i} className="folio-group">
                                                <h5 style={{ margin: "1rem 0" }}>{section.label}</h5>
                                                <table className="report-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Folio</th>
                                                            <th>Opening</th>
                                                            <th>Debit</th>
                                                            <th>Credit</th>
                                                            <th>Closing</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {folios.map((item, idx) => (
                                                            <tr key={idx}>
                                                                <td>{item.accountFolio} - {item.folioReference}</td>
                                                                <td>${item.openingBalance.toFixed(2)}</td>
                                                                <td>${item.debit.toFixed(2)}</td>
                                                                <td>${item.credit.toFixed(2)}</td>
                                                                <td>
                                                                    ${section.key === "tenantFolioList"
                                                                        ? (item.deposit ?? 0).toFixed(2)
                                                                        : (item.closing ?? 0).toFixed(2)}
                                                                </td>                                                            </tr>
                                                        ))}
                                                        <tr className="subtotal-row" style={{ fontWeight: "bold", borderTop: "1px solid #ccc" }}>
                                                            <td>Total {section.label} Funds</td>
                                                            <td>${total.opening.toFixed(2)}</td>
                                                            <td>${total.debit.toFixed(2)}</td>
                                                            <td>${total.credit.toFixed(2)}</td>
                                                            <td>
                                                                ${section.key === "tenantFolioList"
                                                                    ? folios.reduce((sum, f) => sum + (f.deposit ?? 0), 0).toFixed(2)
                                                                    : total.closing.toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <table className="report-table">
                                    <thead>
                                        <tr>
                                            <th>Audit</th>
                                            <th>Date</th>
                                            <th>Ref</th>
                                            <th>Type</th>
                                            <th>Details</th>
                                            <th>Debit</th>
                                            <th>Credit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listViewDetails.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: "center" }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        ) : (
                                            listViewDetails.map((item) => (
                                                <tr key={item.auditNo}>
                                                    <td>{item.auditNo}</td>
                                                    <td>
                                                        {new Date(item.createdOn).toLocaleDateString()}
                                                    </td>
                                                    <td>{item.reference}</td>
                                                    <td>{item.type}</td>
                                                    <td>
                                                        From: {item.fromName} <br />
                                                        To: {item.toFolio} - {item.toName} <br />
                                                        {item.details}
                                                    </td>
                                                    <td>
                                                        {item.debit > 0 ? `$${item.debit.toFixed(2)}` : ""}
                                                    </td>
                                                    <td>
                                                        {item.credit > 0 ? `$${item.credit.toFixed(2)}` : ""}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewReport;
